import { DefaultButton } from "@fluentui/react";
import React from "react";

export default function AllocatedTasks({ data, selectedTaskIndex }) {
  return (
    <>
      <p className="ms-fontSize-14 margin-left task-details-container">
        <strong>Task Name: </strong> {data[selectedTaskIndex]?.TaskName}
        <br />
        <strong>Task Description: </strong>
        {data[selectedTaskIndex]?.TaskDescription}
        <br />
        <strong>Task Completion Date: </strong>
        {data[selectedTaskIndex]?.TaskDeadLine}
        <br />
        <strong>Time Allocated: </strong>
        {data[selectedTaskIndex]?.TimeAllocated}
      </p>
      <div className="bottom-button">
        <DefaultButton>Start</DefaultButton>
        <DefaultButton>End</DefaultButton>
        <DefaultButton>Pause</DefaultButton>
      </div>
    </>
  );
}
